import { cn } from '@shared/lib/cn'
import type { ReactNode } from 'react'

interface MobileShellProps {
  readonly children: ReactNode
  readonly className?: string
}

export function MobileShell({ children, className }: MobileShellProps) {
  return (
    <main
      className={cn(
        'relative mx-auto flex w-full max-w-mobile-shell',
        'h-dvh flex-col overflow-x-hidden overflow-y-auto bg-bg-base',
        'shadow-[0_0_0_1px_var(--border)]',
        className,
      )}
    >
      {children}
    </main>
  )
}
